import axios from 'axios';
import constants from '../constants/constants';

const getCurrentWeatherCondition = (city) => {
    return axios(`${constants.WEATHER_API}${city}?format=j1`)
        .then(res => {
            return res.data.current_condition;
        })
}

export {
    getCurrentWeatherCondition
}